@if (product) {
  <div
    [attr.id]="'product-order-price-' + product.id"
    class="product--price"
    [ngClass]="classes"
  >
    <app-product-price
      [priceRange]="showPriceVariations ? priceVariations : null"
      [price]="price"
      [discount]="discount"
      [fontSize]="fontSize"
      [fontWeight]="fontWeight"
      [orientation]="orientation"
      [originalPrice]="originalPrice"
    ></app-product-price>
    @if (!hideUOM) {
      <div class="uom uppercase">
        <span>{{ pkgQty }}</span>
        @if (canShowPriceTiers) {
          <app-pricing-tiers
            [product]="product"
            [quantity]="quantityForTiers"
            [sku]="sku"
            [modal]="modal"
          ></app-pricing-tiers>
        }
      </div>
    }
  </div>
}
